<template>
    <base-modal
        :reference="'addBusCompany'"
        :title="'Añadir compañía de bus'"
        :acceptAction="acceptAction"
        :cancelActionText="'Cerrar'"
        :size="'md'"
    >
        <template v-slot:body v-if="show">
            <div>
                <p>
                    Añadir una nueva compañía de bus
                </p>
            </div>
            <form>
                <div class="d-flex w-100 my-3">
                    <div class="d-flex flex-column align-items-sm-baseline">
                        <label>Nombre de la compañía <span class="text-danger">[campo obligatorio]</span></label>
                        <b-form-input
                            type="text"
                            v-model="form.name"
                            placeholder="Inserte nombre"
                            style="width: 17vw"
                        ></b-form-input>
                    </div>
                </div>
                <div v-if="errors">
                    <p class="alert-danger py-2 px-4 my-2 font-weight-bold w-75 mx-auto">
                        El campo nombre es obligatorio
                    </p>
                </div>
            </form>
        </template>

    </base-modal>

</template>

<script>
/* eslint-disable */
import BaseModal from "../../Excursions/Booking/Modal/BaseModal";


export default {
    components: {
        BaseModal,
    },
    data() {
        return {
            show: false,
            form: {
                name: ''
            }
        }
    },
    async mounted() {
        this.$root.$on("bv::modal::show", async (bvEvent, modalId) => {
            const current = "addBusCompany";
            if (modalId == current) {
                this.show = true
            }
        })
    },
    methods: {
        async acceptAction() {
            if ( this.errors ) {
                return 
            }
            
            let data = {
                payload: {...this.form}
            }
            await this.$store.dispatch("buscompanies/createBusCompany", data )
            
            // reset form data
            this.form = {
                name: '',
            }

            this.$bvModal.hide("addBusCompany");
            this.$notify({
                group: "foo",
                title: "Compañía de buses añadida",
                text: "Se ha creado una nueva compañía de buses",
                type: "success",
            });
        }
    },
    computed: {
        errors() {
            if ( this.form.name == '' ) {
                return true
            }
            return false
        }
    }
}
</script>